import { DataVizContainerViewConfigWithStateManager } from '../../../common/types';
import {
  OverTimeUnsegmentedVizData,
  OverTimeUnsegmentedVizExternalProps,
} from '../../types';
import { overTimeUnsegmentedTableViewDataToUiComponentProps } from './dataToUiComponentProps';
import {
  OverTimeUnsegmentedTableViewActions,
  OverTimeUnsegmentedTableViewState,
  OverTimeUnsegmentedTableViewUiComponentProps,
} from './types';
import { OverTimeUnsegmentedTableViewUiComponent } from './UiComponent';
import { useOverTimeUnsegmentedTableViewStateManager } from './useStateManager';

export const overTimeUnsegmentedTableViewConfig: DataVizContainerViewConfigWithStateManager<
  OverTimeUnsegmentedVizData,
  OverTimeUnsegmentedVizExternalProps,
  OverTimeUnsegmentedTableViewUiComponentProps,
  OverTimeUnsegmentedTableViewState,
  OverTimeUnsegmentedTableViewActions
> = {
  hasStateManager: true,
  useStateManager: useOverTimeUnsegmentedTableViewStateManager,
  dataToUiComponentProps: overTimeUnsegmentedTableViewDataToUiComponentProps,
  UiComponent: OverTimeUnsegmentedTableViewUiComponent,
};
